import { NeighborhoodInsight } from '../../order/interface/neighborhood.interface';
import { OrderDetail, PropertyMap } from '../../order/interface/order.interface';
import { ExtendedPropertyDetail } from '../../property/interface/property.interface';
import { Scenario, ScenarioMap } from '../../scenario/interface/scenario.interface';

export interface SyncUpdateSet {
  id?: string;
  scope: SyncUpdateScope;
  jsonPath: string;
  value: unknown;
  structure?: number;
  unit?: number;
}

export enum SyncUpdateScope {
  ORDER = 'ORDER',
  PROPERTY = 'PROPERTY',
  SCENARIO = 'SCENARIO',
  STRUCTURE = 'STRUCTURE',
  UNIT = 'UNIT',
}

export enum SyncScope {
  ORDER = 'ORDER',
  SCENARIO_MAP = 'SCENARIO_MAP',
  SCENARIO = 'SCENARIO',
  SUBJECT = 'SUBJECT',
  SALES_SELECTED_COMPS = 'SALES_SELECTED_COMPS',
  COST_SELECTED_COMPS = 'COST_SELECTED_COMPS',
  NEIGHBORHOOD_INSIGHTS = 'NEIGHBORHOOD_INSIGHTS',
  SHORT_TERM_RENTAL_SELECTED_COMPS = 'SHORT_TERM_RENTAL_SELECTED_COMPS',
  LONG_TERM_RENTAL_SELECTED_COMPS = 'LONG_TERM_RENTAL_SELECTED_COMPS',
}

export type SyncStatesWithoutUpdateFnArgs =
  | [scope: SyncScope.ORDER, state: OrderDetail | null]
  | [scope: SyncScope.SCENARIO_MAP, state: ScenarioMap | null]
  | [scope: SyncScope.SCENARIO, state: Scenario | null]
  | [scope: SyncScope.SUBJECT, state: ExtendedPropertyDetail | null]
  | [scope: SyncScope.SALES_SELECTED_COMPS, state: PropertyMap]
  | [scope: SyncScope.COST_SELECTED_COMPS, state: PropertyMap]
  | [scope: SyncScope.SHORT_TERM_RENTAL_SELECTED_COMPS, state: PropertyMap]
  | [scope: SyncScope.LONG_TERM_RENTAL_SELECTED_COMPS, state: PropertyMap]
  | [scope: SyncScope.NEIGHBORHOOD_INSIGHTS, state: NeighborhoodInsight | null];

/** One request a sync pipeline sent, covering every revision from the first not yet dispatched to `to`. */
export interface SyncBatch {
  from: number;
  to: number;
}

/**
 * How far one scope's writes have got. `requested` counts state changes, `dispatched` is the latest
 * revision whose debounce has fired, and `outstanding` holds the requests still running.
 */
export interface SyncRevisions {
  requested: number;
  dispatched: number;
  outstanding: SyncBatch[];
}

export type SyncRevisionMap = Partial<Record<SyncScope, SyncRevisions>>;
